import { colors } from 'ui/theme/colors';
import { getColor } from '../../utils';
import { SvgIcon, SvgIconProps } from '../../SvgIcon';

export const LongArrowRight24 = ({
  height = 24,
  width = 24,
  color = colors.iconPrimary,
  isColorInherited = false,
  ...props
}: SvgIconProps) => (
  <SvgIcon data-temporary-fix height={height} width={width} viewBox="0 0 24 24" {...props}>
    <path
      fillRule="evenodd"
      clipRule="evenodd"
      d="M3.18158 11.7647C3.18158 11.2814 3.57333 10.8897 4.05658 10.8897L18.5425 10.8897C19.0258 10.8897 19.4175 11.2814 19.4175 11.7647C19.4175 12.2479 19.0258 12.6397 18.5425 12.6397L4.05658 12.6397C3.57333 12.6397 3.18158 12.2479 3.18158 11.7647Z"
      fill={getColor(color, isColorInherited)}
    />
    <path
      fillRule="evenodd"
      clipRule="evenodd"
      d="M14.6947 6.45935C15.0364 6.11764 15.5904 6.11764 15.9321 6.45935L20.6187 11.146C20.7828 11.3101 20.875 11.5326 20.875 11.7647C20.875 11.9968 20.7828 12.2193 20.6187 12.3834L15.9321 17.07C15.5904 17.4117 15.0364 17.4117 14.6947 17.07C14.353 16.7283 14.353 16.1743 14.6947 15.8326L18.7626 11.7647L14.6947 7.69678C14.353 7.35507 14.353 6.80105 14.6947 6.45935Z"
      fill={getColor(color, isColorInherited)}
    />
  </SvgIcon>
);
